import { StorageProject } from "../FileManagerFile";

export const FILE_MANAGER_PAGE_SIZES = [12, 24, 48] as const;

export type PaginationItem = number | "ellipsis-start" | "ellipsis-end";

export const normalizeStorageProject = (domain?: string | null): StorageProject => {
    return domain === "me-qr" ? "me-qr" : "me-page";
};

export const getPaginationItems = (page: number, totalPages: number): PaginationItem[] => {
    if (totalPages <= 1) return [];

    const pageItems: PaginationItem[] = [1];
    const visiblePagesAroundCurrent = 2;
    const start = Math.max(page - visiblePagesAroundCurrent, 2);
    const end = Math.min(page + visiblePagesAroundCurrent, totalPages - 1);

    if (start > 2) pageItems.push("ellipsis-start");

    for (let pageNumber = start; pageNumber <= end; pageNumber += 1) {
        pageItems.push(pageNumber);
    }

    if (end < totalPages - 1) pageItems.push("ellipsis-end");

    pageItems.push(totalPages);

    return pageItems;
};
